export function saveToLocal(name, value) {
  try {
    if (typeof value == "object") {
      value = JSON.stringify(value)
    }
  } catch (e) {

  }
  window.localStorage.setItem(name, value)
};

export function loadFromLocal(name) {
  let value = window.localStorage.getItem(name)
  try {
    if (typeof JSON.parse(value) == "object") {
      value= JSON.parse(value)
    }
  } catch (e) {
  }
  return value
};

export function removeFromLocal(name) {
    window.localStorage.removeItem(name)
}



// WEBPACK FOOTER //
// ./src/utils/localStorage.js